import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';
import ProtocolExportVisitForm from '../ProtocolExportVisits/Protocol.ExportVisit.Form.Component';
import { Button } from '@fluentui/react-components';
import { FaFileExcel } from 'react-icons/fa';

const ProtocolsMenuComponent = () => {
    const [t] = useTranslation();
    const [showExportForm, setShowExportForm] = useState(false);

    return (
        <>
            <Button
                appearance="primary"
                onClick={() => setShowExportForm(true)}
                icon={<FaFileExcel />}
            >
                {t('protocolExportVisitForm.title')}
            </Button>

            <ProtocolExportVisitForm 
                isOpen={showExportForm} 
                onClose={() => setShowExportForm(false)} 
            />
        </>
    );
};

export default ProtocolsMenuComponent;